import { createI18n } from 'vue-i18n'
import en from './locales/en'
import ru from './locales/ru'
import vi from './locales/vi'
import ko from './locales/ko'

const availableLocales = ['en', 'ru', 'vi', 'ko']

function getDefaultLocale() {
  const saved = localStorage.getItem('locale')
  if (saved && availableLocales.includes(saved)) return saved

  const browser = (navigator.language || navigator.userLanguage || 'en').split('-')[0].toLowerCase()
  if (availableLocales.includes(browser)) return browser

  return 'en'
}

export default createI18n({
  legacy: false,
  locale: getDefaultLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    ru,
    vi,
    ko
  }
}) 